import './App.css';
import About from './pages/About/About';
import Authentication from './pages/Authentication/Authentication';
import Contact from './pages/Contact/Contact';
import Landing from './pages/Landing/Landing';
import PaymentForm from './pages/Payment/Payment';
import './styles/global.css'
import './styles/variables.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { AuthProvider } from './contexts/AuthContext';
import TermsOfServices from './pages/TermsOfServices/TermsOfServices';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import FAQ from './pages/FAQ/FAQ';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Investment from './pages/Investment/Investment';
import OTPVerification from './pages/OTPVerification/OTPVerification';
import Profile from './pages/Profile/Profile';
import PrivateRoute from './components/PrivateRoute';
import Feed from './pages/Feed/Feed';
import SetupAccount from './pages/SetupAccount/SetupAccount';
import FeedDetails from './components/FeedDetails/FeedDetails';
import Settings from './pages/Settings/Settings';
import AccountSettings from './pages/AccountSettings/AccountSettings';
import ProfilePosts from './pages/ProfilePosts/ProfilePosts';
import Create from './pages/Create/Create';
import Follows from './pages/Follows/Follows';
import ProfileStore from './pages/ProfileStore/ProfileStore';
import SavedPosts from './pages/SavedPosts/SavedPosts';
import Deposit from './pages/Deposit/Deposit';
import CurrencyConverter from './pages/CurrencyConverter/CurrencyConverter';
import Help from './pages/Help&Feedbacks/Help&Feedbacks';
import Search from './pages/Search/Search';
import Wallet from './pages/Wallet/Wallet';
import Chat from './pages/Chat/Chat';
import Products from './pages/Products/Products';
import ProductDetails from './pages/ProductDetails/ProductDetails';
import Cart from './pages/Cart/Cart';
import StoreUnfulfilledOrders from './pages/StoreUnfulfilledOrders/StoreUnfulfilledOrders';
import StoreStatistics from './pages/StoreStatistics/StoreStatistics';
import AddProduct from './pages/AddProduct/AddProduct';
import InvestmentSuccess from './pages/InvestmentSuccess/InvestmentSuccess';
import InvestmentCancel from './pages/InvestmentCancel/InvestmentCancel';
import WinisPurchaseSuccess from './pages/WinisPurchaseSuccess/WinisPurchaseSuccess';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import Send from './pages/Send/Send';
import QRScan from './pages/Send/QRScan';
import SendSearch from './pages/Send/SendSearch';
import Sending from './pages/Send/Sending';
import Card from './pages/Card/Card';
import Transaction from './pages/Transaction/Transaction';
import TransactionDetails from './pages/TransactionDetails/TransactionDetails';
import ShortInvestmentPage from './pages/ShortInvestmentPage/ShortInvestmentPage';
import Press from './pages/Press/Press';
import MediaKits from './pages/MediaKits/MediaKits';
import PressInquiries from './pages/PressInquiries/PressInquiries';
import ThankYou from './pages/ThankYou/ThankYou';
import EditProfile from './pages/EditProfile/EditProfile';
import CustomizeStats from './pages/CustomizeStats/CustomizeStats';
import ViewPost from './pages/ViewPost/ViewPost';
import ViewProfile from './pages/ViewProfile/ViewProfile';
import ViewProduct from './pages/ViewProduct/ViewProduct';
import Insights from './pages/Insights/Insights';
// import ConnectionProbe from './components/connectionprobsupa';

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <ScrollToTop />
          {/* <ConnectionProbe/>         */}
          <Routes>
            <Route path="/" element={<Authentication />} />
            <Route path="/otp-verification" element={<OTPVerification />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path='/payment' element={<PaymentForm />} />
            <Route path='/terms-of-services' element={<TermsOfServices />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/investment' element={<Investment />} />
            <Route path='/buy-winis' element={<ShortInvestmentPage />} />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile/:id"
              element={
                <Profile />
              }
            />
            <Route path='/profile_posts/:id' element={
              <PrivateRoute>
                <ProfilePosts />
              </PrivateRoute>
            }
            />
            <Route path='/insights/:postId' element={
              <PrivateRoute>
                <Insights />
              </PrivateRoute>
            }
            />
            <Route
              path="/feed"
              element={
                <PrivateRoute>
                  <Feed />
                </PrivateRoute>
              }
            />
            <Route
              path="/setup-account"
              element={
                <PrivateRoute>
                  <SetupAccount />
                </PrivateRoute>
              }
            />
            <Route path="/feed-details/:postId" element={
              <PrivateRoute>
                <FeedDetails />
              </PrivateRoute>
            }
            />
            <Route path='/settings' element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
            />
            <Route path='/edit-profile' element={
              <PrivateRoute>
                <EditProfile />
              </PrivateRoute>
            } />
            <Route path='/customize-stats' element={
              <PrivateRoute>
                <CustomizeStats />
              </PrivateRoute>
            } />
            <Route path='/account-settings' element={
              <PrivateRoute>
                <AccountSettings />
              </PrivateRoute>
            }
            />
            <Route path='/create' element={
              <PrivateRoute>
                <Create />
              </PrivateRoute>
            }
            />
            <Route path='/follows' element={<Follows />} />

            {/* Send routes MUST come before /:username/:userId fallback */}
            <Route path='/send/search' element={
              <PrivateRoute>
                <SendSearch />
              </PrivateRoute>
            } />
            <Route path='/sending' element={
              <PrivateRoute>
                <Sending />
              </PrivateRoute>
            } />

            {/* Product share routes - MUST come before profile and post routes to match /pr suffix */}
            {/* Shape: /@username/:productId/:shareId/pr */}
            <Route path="/:username/:productId/:shareId/pr" element={<ViewProduct />} />
            {/* Profile share routes - MUST come before post routes to match /u suffix */}
            {/* Note: React Router captures @ as part of username param, so we use :username pattern */}
            <Route path="/:username/:userId/:shareId/u" element={<ViewProfile />} />
            {/* Post share routes - support both with and without /p for backwards compatibility */}
            <Route path="/:username/:postId/:shareId/p" element={<ViewPost />} />
            {/* Fallback routes - order matters: product routes before profile routes before post routes */}
            {/* Shape: /@username/:productId/pr */}
            <Route path="/:username/:productId/pr" element={<ViewProduct />} />
            <Route path="/:username/:userId/:shareId" element={<ViewProfile />} />
            <Route path="/:username/:postId/:shareId" element={<ViewPost />} />
            <Route path="/:username/:userId" element={<ViewProfile />} />
            <Route path="/:id/store" element={<ProfileStore />} />
            <Route path="/saved" element={
              <PrivateRoute>
                <SavedPosts />
              </PrivateRoute>
            } />
            <Route path='/deposit' element={<Deposit />} />
            <Route path='/help&feedbacks' element={<Help />} />
            <Route path='/search' element={
              <PrivateRoute>
                <Search />
              </PrivateRoute>
            } />
            <Route path='/wallet' element={
              <PrivateRoute>
                <Wallet />
              </PrivateRoute>
            } />
            <Route path='/currency-converter' element={
              <PrivateRoute>
                <CurrencyConverter />
              </PrivateRoute>
            } />
            <Route path='/chat' element={
              <PrivateRoute>
                <Chat />
              </PrivateRoute>
            } />
            <Route path='/products/:id' element={
              <PrivateRoute>
                <Products />
              </PrivateRoute>
            } />
            <Route path='/product-details/:uid/:productId' element={
              <PrivateRoute>
                <ProductDetails />
              </PrivateRoute>
            } />
            <Route path='/cart' element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            } />
            <Route path='/cart/:storeId' element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            } />
            <Route path='/store/unfulfilled-orders' element={
              <PrivateRoute>
                <StoreUnfulfilledOrders />
              </PrivateRoute>
            } />
            <Route path='/store/statistics' element={
              <PrivateRoute>
                <StoreStatistics />
              </PrivateRoute>
            } />
            <Route path='/add-product' element={
              <PrivateRoute>
                <AddProduct />
              </PrivateRoute>
            } />
            <Route path='/investment-success' element={
              <PrivateRoute>
                <InvestmentSuccess />
              </PrivateRoute>
            } />
            <Route path='/investment-cancel' element={
              <PrivateRoute>
                <InvestmentCancel />
              </PrivateRoute>
            } />
            <Route path='/winis-purchase-success' element={
              <PrivateRoute>
                <WinisPurchaseSuccess />
              </PrivateRoute>
            } />
            <Route path='/payment-success' element={
              <PrivateRoute>
                <PaymentSuccess />
              </PrivateRoute>
            } />
            <Route path='/send' element={
              <PrivateRoute>
                <Send />
              </PrivateRoute>
            } />
            <Route path='/send/qr-scan' element={
              <PrivateRoute>
                <QRScan />
              </PrivateRoute>
            } />
            <Route path='/card' element={
              <PrivateRoute>
                <Card />
              </PrivateRoute>
            } />
            <Route path='/trans' element={
              <PrivateRoute>
                <Transaction />
              </PrivateRoute>
            } />
            <Route path='/trans-details/:transactionId' element={
              <PrivateRoute>
                <TransactionDetails />
              </PrivateRoute>
            } />
            <Route path='/press' element={<Press />} />
            <Route path='/press/media-kits' element={<MediaKits />} />
            <Route path='/press/inquiries' element={<PressInquiries />} />
            <Route path='/thank-you' element={<ThankYou />} />

            {/* Simple username route - must come AFTER all specific routes */}
            {/* Shape: /@username → opens ViewProfile (or app if installed) */}
            {/* Note: React Router captures @ as part of username param */}
            <Route path="/:username" element={<ViewProfile />} />

          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
